import React, { useState, useEffect } from 'react'
import { Row, Col, Input, Button } from 'reactstrap'
import { Select } from "react-inputs-validation";
import NumberFormat from 'react-number-format';
const ValoresCobertura = ({ data, i, handleBack, handleClick, final, idCobertura, cliCodigoCore, mostrarRotura, estadoActualizar, setEstadoActualizar, hasSiguienteUbicacion }) => {
    const [datos, setDatos] = useState(data);
    const cambiarDatos = async (value, j) => {
        const value2 = parseFloat(datos[j].value)
        let valor = datos[j].valor
        console.log(valor)
        if (Array.isArray(valor)) {
            let data = [...datos]
            data[j] = { ...datos[j], value: `${value}` }
            setEstadoActualizar(true)
            setDatos(data)
        } else
            valor = parseFloat(datos[j].valor)
        if (value >= 0 && value2 !== value && value <= valor) {
            let data = [...datos]
            data[j] = { ...datos[j], value }
            setEstadoActualizar(true)
            setDatos(data)
        }
    }

    useEffect(() => {
        let data = [...datos]
        let data2 = [...data]
        data.forEach(({ valor, value }, i) => {

            if (Array.isArray(valor) && value === 0) {

                data2[i] = { ...data2[i], value: `${valor[0]}` }
            }
        });
        setDatos(data2)
    }, [])


    useEffect(() => {
        setDatos(data)
    }, [data])


    return (
        <div>

            {datos.map(({ codigo, descripcion, valor, value }, j) =>
                <div key={'dataubicaciones' + i + '-' + j}>
                    <Row >
                        <Col xs={6} sm={4} > <p style={{ color: (parseInt(valor) === 0 ? '#989898' : null) }} >{descripcion} </p> </Col>
                        {console.log('aaa', codigo, descripcion, value)}
                        {Array.isArray(valor) ? <>
                            <Col xs={6} sm={5}>
                                <Select
                                    //tabIndex="6" // Optional.[String or Number].Default: none.
                                    id={"selectTipoDoc"} // Optional.[String].Default: "". Input ID.
                                    name={"selectTipoDoc"} // Optional.[String].Default: "". Input name.
                                    value={value} // Optional.[String].Default: "".
                                    validate={true}
                                    optionList={valor} // Required.[Array of Object(s)].Default: [].
                                    onChange={(value) => { console.log('aaa', value); cambiarDatos(value, j) }}
                                    // Optional.[Func].Default: () => {}. Will return the value.
                                    onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                    //customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                                    //validationCallback={res => this.setState({ hasCodTipoDocError: res, validate: false })}
                                    validationOption={{
                                        name: "selectTipoDoc", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                        msgOnError: "Por favor seleccione el tipo de documento"
                                    }}
                                />
                            </Col>
                        </> : <>
                            <Col xs={6} sm={5}>

                                <NumberFormat
                                    className="form-control"
                                    disabled={(parseInt(valor) === 0)}
                                    value={value > valor ? 0 : value}
                                    thousandSeparator={','}
                                    decimalSeparator={'.'}
                                    style={{
                                        width: 'inherit', fontSize: 20, textAlign: 'right',
                                        background: (parseInt(valor) === 0 ? '#f5f5f5' : null)
                                    }}
                                    decimalScale={2}
                                    prefix={''}
                                    onValueChange={(valor, e) => {

                                        console.log('Valor', valor)
                                        cambiarDatos(valor.formattedValue, j)


                                    }}

                                />
                            </Col>
                            <Col sm={3}> <p style={{ textAlign: 'right', color: '#909090', color: (parseInt(valor) === 0 ? '#989898' : null) }}>{valor.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</p> </Col>
                        </>}


                    </Row>

                </div>
            )}
            <div className='flex' style={{ margin: 10, }}  >

                <Button className="btn btn-detail-gray" onClick={() => handleBack()} style={{ margin: "auto" }} >
                    <i className="fa fa-chevron-circle-left" aria-hidden="true" />{"  REGRESAR"}
                </Button>
                <Button disabled={estadoActualizar ? false : !hasSiguienteUbicacion} className={estadoActualizar ? 'btn btn-purple fe-pulse' : 'btn btn-primary'} onClick={() => { handleClick(datos, i) }} style={{ margin: "auto", }} >
                    <i className="fa fa-chevron-circle-right " aria-hidden="true" />{estadoActualizar ? ' ACTUALIZAR VALORES' : ' SIGUIENTE'}
                </Button>
            </div>
        </div>
    )
}

export default ValoresCobertura